import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const MarkantCreator = () => {
  const { t } = useTranslation();

  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('markant')}</Typography>
    </div>
  );
};

export default MarkantCreator;
